export enum FnsRegistryCheckMessageEnum {
  NO_DATA_53_MESSAGE = 'Сверка данных о контролируемом лице с ФНС не выполнена',
  NO_DATA_56_MESSAGE = 'Выписка не может быть предоставлена в текущий момент. Необходимо обратиться в службу технической поддержки',
  DATA_NOT_EQUALS_ERVK_MESSAGE = 'Данные не соответствуют информации из ФНС России, внесите изменение в ЕРВК',
  PLEASE_SAVE_KNM = 'Сохраните КНМ и ожидайте загрузки информации из ФНС России, время ожидания составляет до 2 часов.',
}
